function TermsOfService() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <header className="p-4 md:flex md:justify-between md:items-center bg-white shadow-sm">
                <div className="font-bold text-xl text-center">
                    <i className="far fa-wave-pulse mr-2 text-teal-700"></i>
                    Home<span className="text-teal-700">Pulse</span>
                </div>
                <div className="hidden md:block">
                    <a href="/" className="px-4 py-2 rounded-md border-teal-700 text-teal-700 border rounded-md font-semibold cursor-pointer">
                        <i className="far fa-arrow-left mr-2"></i>
                        Back to Home
                    </a>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-4xl mx-auto p-6 py-12">
                <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
                    {/* Title */}
                    <div className="text-center mb-12">
                        <h1 className="text-3xl md:text-4xl font-bold text-teal-900 mb-4">
                            Terms of Service
                        </h1>
                        <p className="text-lg text-teal-800">
                            Last Updated: August 4, 2025
                        </p>
                    </div>

                    <section className="mb-12" id="terms-of-service">
                        <h2 className="text-2xl font-bold text-teal-900 mb-6">Terms of Service</h2>
                        
                        <div className="space-y-6 text-gray-700 leading-relaxed">
                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">Introduction and Acceptance of Terms</h3>
                                <p className="mb-4">
                                    These Terms of Service ("Terms") are a binding agreement between you ("User" or "you") and DICE Digital, a company incorporated 
                                    in the State of Georgia, USA ("Company", "we", or "us"), which owns and operates the HomePulseTracker website and service 
                                    ("HomePulseTracker" or the "Service"). HomePulseTracker is an online service that allows users to receive monthly email reports 
                                    of changes in their home's estimated value, using data sourced from third-party real estate services (such as Zillow, Realtor.com, and Redfin).
                                </p>
                                <p>
                                    By accessing or using HomePulseTracker (for example, by submitting your email and address to sign up for the monthly report), 
                                    you agree to be bound by these Terms. If you do not agree with these Terms, you must not use the Service. Please also review our 
                                    Privacy Policy (above or linked on our website), which describes how we collect and use your information. Your use of the Service 
                                    signifies your agreement to the Privacy Policy as well.
                                </p>
                            </div>

                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">Eligibility</h3>
                                <p className="mb-4">
                                    You must be at least 18 years old to use HomePulseTracker. By using this Service, you represent that you are 18 or older and 
                                    capable of entering into a binding contract. If you are using the Service on behalf of another person (such as a spouse or family member) 
                                    or an organization, you represent that you have the authority to do so and to bind that person or entity to these Terms.
                                </p>
                                <p>
                                    The Service is intended for personal, non-commercial use by individual homeowners or those with a legitimate interest in tracking 
                                    a property's value. You agree that you will not use HomePulseTracker for any commercial purpose (for example, as a real estate agent 
                                    adding client addresses without authorization, or a business aggregating data) without our express written permission.
                                </p>
                            </div>

                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">Service Description and Usage</h3>
                                <p className="mb-4">
                                    HomePulseTracker provides you with home value information on a monthly basis, free of charge. Specifically, once you sign up, 
                                    we will send you a monthly email report that includes estimated valuation data for the property address you provided. These estimates 
                                    are obtained from third-party real estate services (e.g., Zillow, Realtor.com, Redfin) through their APIs.
                                </p>
                                <p className="mb-4">
                                    By using the Service, you understand and agree that:
                                </p>
                                <div className="space-y-4">
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Information Sources:</h4>
                                        <p>
                                            The home valuation data we deliver is produced by independent third parties. HomePulseTracker simply retrieves and aggregates 
                                            this information for your convenience. We are not the creators of the valuation estimates, and we do not guarantee their accuracy 
                                            or completeness. The values are for informational purposes only and should not be relied on as professional appraisal or financial advice.
                                        </p>
                                    </div>
                                    
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Third-Party Trademarks and Attribution:</h4>
                                        <p>
                                            Zillow, Realtor.com, Redfin, and any other third-party providers referenced are independent companies with no affiliation 
                                            to DICE Digital or HomePulseTracker. All trademarks, service marks, and names of third-party services remain the property 
                                            of their respective owners.
                                        </p>
                                    </div>
                                    
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Service Limitations:</h4>
                                        <p>
                                            We aim to deliver emails monthly, but the exact timing may vary. We reserve the right to adjust the frequency or content 
                                            of emails. Additionally, because we rely on third-party APIs, there may be occasions when those services are down or data 
                                            is not updated. HomePulseTracker is provided on an "as available" basis.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Contact Information */}
                    <section className="bg-teal-50 rounded-lg p-6 mt-12">
                        <h3 className="text-xl font-semibold text-teal-900 mb-4">Contact Us</h3>
                        <div className="space-y-2 text-gray-700">
                            <p><strong>Email:</strong> support@homepulsetracker.com</p>
                            <p><strong>Company:</strong> DICE Digital (Inc.), incorporated in the State of Georgia, USA</p>
                            <p className="text-sm text-gray-600">
                                If you have any questions, concerns, or requests regarding this Privacy Policy or your personal information, 
                                please contact us. We will do our best to address any issue or inquiry promptly.
                            </p>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}

export default TermsOfService;
